import React from 'react';
import './CTASection.css';
import Button from '../../ui/Button';

/**
 * Reusable CTA Section Component
 * 
 * @param {string} title - Main heading text
 * @param {string} subtitle - Subtitle text (optional)
 * @param {string} backgroundImage - URL for background image (optional)
 * @param {Array} buttons - Array of button objects { text, link, type ('primary'|'secondary'), isExternal, ariaLabel }
 * @param {string} align - Text alignment ('center' | 'left' | 'right') - default 'center'
 * @param {string} overlayColor - Custom overlay color (optional)
 * @param {string} className - Additional CSS classes
 */
const CTASection = ({
  title,
  subtitle,
  backgroundImage,
  buttons = [],
  align = 'center',
  overlayColor,
  className = '',
  id,
  isHero = false,
  imageSrcSet,
  imageSizes
}) => {

  const sectionStyle = backgroundImage
    ? { backgroundImage: `url("${backgroundImage}")` }
    : {};

  const overlayStyle = overlayColor
    ? { backgroundColor: overlayColor }
    : {};

  return (
    <section
      className={`cta-section ${className}`}
      style={!isHero ? sectionStyle : undefined}
      aria-labelledby={`${id}-heading`}
    >
      {isHero && backgroundImage && (
        <img
          src={backgroundImage}
          srcSet={imageSrcSet}
          sizes={imageSizes}
          alt={title}
          className="cta-background-image"
          fetchPriority={isHero ? "high" : "auto"}
          loading={isHero ? "eager" : "lazy"}
          width="768"
          height="240"
          decoding="async"
        />
      )}
      <div className="cta-overlay" style={overlayStyle}></div>

      <div className={`cta-content glass-container align-${align}`}>
        <h2 id={`${id}-heading`} className="cta-title">
          {title}
        </h2>

        {subtitle && (
          <div className="cta-subtitle">
            <p>{subtitle}</p>
          </div>
        )}

        {buttons.length > 0 && (
          <div className="cta-buttons">
            {buttons.map((btn, index) => (
              <Button
                key={index}
                variant={btn.type === 'secondary' ? 'secondary' : 'primary'}
                to={!btn.isExternal ? btn.link : undefined}
                href={btn.isExternal ? btn.link : undefined}
                ariaLabel={btn.ariaLabel || btn.text}
              >
                {btn.text}
              </Button>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default CTASection;
